import { useHistory } from "react-router-dom";
import { getAppConfig } from "../../config";
import { useEffect } from "react";
import { initializeGA } from "../../lib/analytics";

interface AnalyticsProps {
    children: JSX.Element;
}
const Analytics = (props: AnalyticsProps) => {
    const { listen } = useHistory();
    const config = getAppConfig();
    useEffect(() => {
        if (config.appEnvName !== "production") return;
        const trackingId = "G-W8R05P560L";
        initializeGA(trackingId);

        return listen((location) => {
            if (!window.gtag) return;
            window.gtag("config", trackingId, { page_path: location.pathname });
        });
    }, []);
    return props.children;
};

export default Analytics;
